import React, { useState, FormEvent, ChangeEvent } from 'react';
import NavbarSidebarLayout from '../layouts/navbar-sidebar';
import toast, { Toaster } from 'react-hot-toast';
import { contactService } from '../services/main';

function ContactForm() {
    const [subject, setSubject] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const user = sessionStorage.getItem('user');
    if (!user) {
        toast.error('User not found in session storage.');
        return null;
    }

    const parsedUser = JSON.parse(user);
    const [email, setEmail] = useState<string>(parsedUser.email || '');

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSubmitting(true);

        try {
            await contactService.createContactMessage({ email, subject, message });
            toast.success('Message sent successfully!');
            setSubject('');
            setMessage('');

        } catch (error: any) {
            console.log("Error:", error);
            const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
            toast.error(`Error: ${errorMessage}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubjectChange = (e: ChangeEvent<HTMLInputElement>) => setSubject(e.target.value);
    const handleMessageChange = (e: ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value);

    return (
        <NavbarSidebarLayout>
            <div>
                <section className="bg-white dark:bg-gray-900">
                    <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
                            Contact Us
                        </h2>
                        <p className="mb-8 lg:mb-16 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">
                            Got a technical issue? Want to send feedback about a beta feature? Need
                            details about our Business plan? Let us know.
                        </p>
                        <form onSubmit={handleSubmit} className="space-y-8">
                            {/* <div>
                                <label
                                    htmlFor="email"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                    Your email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    disabled
                                    className="shadow-sm bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 opacity-75 dark:bg-gray-800 dark:border-gray-700 dark:placeholder-gray-400 dark:text-gray-500"
                                />
                            </div> */}
                            <div>
                                <label
                                    htmlFor="subject"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                    Subject
                                </label>
                                <input
                                    type="text"
                                    id="subject"
                                    value={subject}
                                    onChange={handleSubjectChange}
                                    className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                    placeholder="Let us know how we can help you"
                                    required
                                />
                            </div>
                            <div className="sm:col-span-2">
                                <label
                                    htmlFor="message"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                                >
                                    Your message
                                </label>
                                <textarea
                                    id="message"
                                    rows={6}
                                    value={message}
                                    onChange={handleMessageChange}
                                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                    placeholder="Leave a comment..."
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className={`py-3 px-5 text-sm font-medium text-center text-white rounded-lg ${isSubmitting ? 'bg-gray-500' : 'bg-primary-700 hover:bg-primary-800'
                                    } sm:w-fit focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Sending...' : 'Send message'}
                            </button>
                        </form>
                    </div>
                </section>
            </div>
        </NavbarSidebarLayout>
    );
}

export default ContactForm;
